import React, { useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import ReactApexChart from "react-apexcharts";

const RevenueChart = () => {
  const [year, setYear] = useState("2025");

  // 👉 You can later change data based on selected year
  const getSeriesData = () => {
    if (year === "2024") {
      return [
        { name: "Income Base", data: [20, 18, 22, 24, 23, 24, 25, 26, 24, 23, 21, 22] },
        { name: "Income Mid", data: [25, 12, 18, 26, 28, 29, 27, 28, 29, 27, 10, 25] },
        { name: "Income Top", data: [10, 5, 3, 20, 25, 30, 20, 22, 24, 26, 5, 20] },
      ];
    }

    if (year === "2023") {
      return [
        { name: "Income Base", data: [15, 16, 18, 20, 21, 22, 23, 22, 21, 20, 18, 19] },
        { name: "Income Mid", data: [20, 10, 15, 22, 24, 25, 26, 24, 23, 22, 8, 20] },
        { name: "Income Top", data: [5, 2, 1, 15, 18, 20, 18, 19, 20, 22, 2, 15] },
      ];
    }

    // Default 2025
    return [
      {
        name: "Income Base",
        data: [25, 20, 25, 25, 25, 25, 25, 25, 25, 25, 20, 25],
      },
      {
        name: "Income Mid",
        data: [30, 10, 20, 30, 30, 30, 30, 30, 30, 30, 0, 30],
      },
      {
        name: "Income Top",
        data: [5, 0, 0, 25, 30, 35, 25, 25, 25, 30, 0, 25],
      },
    ];
  };

  const series = getSeriesData();

  const options = {
    chart: { type: "bar", stacked: true, toolbar: { show: false } },
    colors: ["#f97316", "#134e5e", "#2f7de1"],
    grid: { borderColor: "#e9ecef", strokeDashArray: 5 },
    plotOptions: { bar: { borderRadius: 6 } },
    dataLabels: { enabled: false },
    legend: { show: false },

    tooltip: {
      enabled: true,
      custom: function ({ series, dataPointIndex, w }) {
        const total = 100;
        const base = series[0][dataPointIndex] || 0;
        const mid = series[1][dataPointIndex] || 0;
        const top = series[2][dataPointIndex] || 0;
        const remaining = total - (base + mid + top);
        const month = w.config.xaxis.categories[dataPointIndex];

        const dot = (color) =>
          `<span style="
            display:inline-block;
            width:10px;
            height:10px;
            border-radius:50%;
            background:${color};
            margin-right:6px;
          "></span>`;

        return `
          <div style="padding:12px 16px; background:#fff; border-radius:12px; box-shadow:0 8px 25px rgba(0,0,0,0.08); font-size:14px; max-width:240px;">
            <div style="font-weight:600; margin-bottom:8px;">${month}</div>

            <div style="margin-bottom:4px;">
              ${dot(w.config.colors[0])}Income Base: <strong>${base}K</strong>
            </div>

            <div style="margin-bottom:4px;">
              ${dot(w.config.colors[1])}Income Mid: <strong>${mid}K</strong>
            </div>

            <div style="margin-bottom:4px;">
              ${dot(w.config.colors[2])}Income Top: <strong>${top}K</strong>
            </div>

            <div style="border-top:1px solid #e9ecef; margin-top:6px; padding-top:6px;">
              ${dot("#e9ecef")}Remaining/Expenses: <strong>${remaining}K</strong>
            </div>
          </div>
        `;
      },
    },

    xaxis: {
      categories: [
        "Jan","Feb","Mar","Apr","May","Jun",
        "Jul","Aug","Sep","Oct","Nov","Dec",
      ],
    },

    yaxis: {
      max: 100,
      labels: { formatter: (val) => val + "K" },
    },
  };

  return (
    <Card
      className="shadow-sm border-0 d-flex flex-column m-0"
      style={{ borderRadius: "14px" }}
    >
      <Card.Header className="bg-white border-0 d-flex justify-content-between align-items-center">
        <h5 className="fw-semibold mb-0">Revenue</h5>

        <Dropdown align="end">
          <Dropdown.Toggle size="sm" variant="light" className="border">
            {year}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {["2025", "2024", "2023", "2022"].map((yr) => (
              <Dropdown.Item key={yr} onClick={() => setYear(yr)}>
                {yr}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </Card.Header>

      <Card.Body className="flex-grow-1">
        <div className="d-flex justify-content-between mb-3">
          <div>
            <h4 className="fw-bold">$45787</h4>
            <p className="mb-0">
              <span className="text-success fw-bold">+40%</span>{" "}
              <span style={{ color: "#6c757d" }}>
                increased from last year
              </span>
            </p>
          </div>
          <div style={{ color: "#f97316" }}>● Revenue</div>
        </div>

        <ReactApexChart
          options={options}
          series={series}
          type="bar"
          height={280}
        />
      </Card.Body>
    </Card>
  );
};

export default RevenueChart;